import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FormComponent } from './form/form.component';
import { HttpClientModule } from '@angular/common/http';
import { FormService } from './services/form.service';
import { PaymentResultComponent } from './payment-result/payment-result.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { FooterComponent } from './footer/footer.component';
import { RelojComponent } from './reloj/reloj.component';
import { OfflineFormComponent } from './offline-form/offline-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfigurationService } from 'kolektor-services';
import { KolektorUiComponentsModule } from 'kolektor-ui-components';
import { CookieService } from 'ngx-cookie-service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderConfigurationService } from './services/header-configuration.service';
import { GlobalErrorHandlerService } from 'src/app/services/global-error-handler.service';
import { LogglyLoggerService } from 'kolektor-services';
import localeES from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeES, 'es');
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

LogglyLoggerService.projectName = 'front_decidir_2';

@NgModule({
  declarations: [
    AppComponent,
    FormComponent,
    PaymentResultComponent,
    PageHeaderComponent,
    FooterComponent,
    RelojComponent,
    OfflineFormComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    KolektorUiComponentsModule,
    NgbModule,
    BrowserAnimationsModule
  ],
  providers: [
    ConfigurationService,
    LogglyLoggerService,
    CookieService,
    HeaderConfigurationService,
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    FormService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
